// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"T","header":"U","title":"V","description":"W","subHeader":"X","button":"Y"};